// Estilo para encabezado alineado a la izquierda
export const headCellLeftAlign = {
  "& .Mui-TableHeadCell-Content": {
    display: "flex",
    //flexDirection: "row-reverse",
    alignItems: "flex-start",
    justifyContent: "left",
    gap: "4px",
    fontFamily: "Nunito, medium",
    fontSize: "14px",
  },
  "& .Mui-TableHeadCell-Content-Labels": {
    display: "flex",
    alignItems: "left",
  },
  "& .MuiTableSortLabel-icon": { display: "none" },
  // evita que el usuario ordene haciendo click en el header
  "& .MuiTableSortLabel-root": { pointerEvents: "none", display: "none" },
  lineHeight: "1.43",
};

// Estilo para encabezado alineado al centro
export const headCellCenterAlign = {
  "& .Mui-TableHeadCell-Content": {
    display: "flex",
    //flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",

    fontFamily: "Nunito, medium",
    fontSize: "14px",
  },
  "& .Mui-TableHeadCell-Content-Labels": {
    display: "flex",
    alignItems: "center",
  },
  "& .MuiTableSortLabel-icon": { display: "none" },
  // evita que el usuario ordene haciendo click en el header
  "& .MuiTableSortLabel-root": { pointerEvents: "none", display: "none" },
  lineHeight: "1.43",
  minWidth: 0,
  p: 0.5,
};

// Estilo para celdas del cuerpo centradas
export const bodyCellCenterAlign = {
  textAlign: "center",
  fontFamily: "Nunito, regular",
  fontSize: "14px",
};
